export default __webpack_public_path__ + "static/media/umi_mddrrmo2.936a0b36.png";